<template>
  <div id="data-list-list-view" class="data-list-container">
    <div class="flex items-center justify-between mb-3"></div>
    <VehicleForm
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />
    <vx-card
      title="Vehicles"
      collapse-action
      refresh-content-action
      @refresh="closeCardAnimationDemo"
    >
      <vs-table
        ref="table"
        pagination
        :max-items="itemsPerPage"
        v-if="vehicles"
        search
        :data="vehicles.vehicles || []"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ADD NEW -->
            <div
              class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center font-medium text-base text-primary border border-solid border-primary"
              @click="addNewData"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add Vehicle</span>
            </div>
          </div>
        </div>
        <template slot="thead">
          <vs-th sort-key="vehicle_id">Vehicle ID</vs-th>
          <vs-th sort-key="make">Make / Model</vs-th>
          <vs-th sort-key="license_plate_num">License Plate No</vs-th>
          <vs-th sort-key="eld_id">ELD No</vs-th>
          <vs-th sort-key="codriver">Telematics</vs-th>
          <vs-th sort-key="notes">Device Version</vs-th>
          <vs-th sort-key="notes_vehicle">Notes</vs-th>
          <vs-th sort-key="notes">Status</vs-th>
          <vs-th>Edit / Deactivate</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody class="nmadir">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p
                  class="product-name font-medium truncate"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.vehicle_id }}
                </p>
              </vs-td>
              <vs-td>
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.model }} {{ tr.make }}
                </p>
              </vs-td>
              <vs-td>
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.license_plate_num }}
                </p>
              </vs-td>
              <vs-td>
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.eld_id }}
                </p>
              </vs-td>
              <vs-td>
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  <feather-icon
                    icon="WifiIcon"
                    svgClasses="w-5 h-5 text-danger stroke-current"
                    class="ml-6"
                  />
                </p>
              </vs-td>
              <vs-td>
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.device_version || "IOSX/2.33" }}
                </p>
              </vs-td>
              <vs-td class="pr-2">
                <p
                  class="product-category"
                  :style="
                    tr.status === false ? 'text-decoration: line-through' : ''
                  "
                >
                  {{ tr.notes_vehicle || "&" }}
                </p>
              </vs-td>
              <vs-td>
                <vs-chip
                  :color="getOrderStatusColor(tr.status)"
                  class="product-order-status"
                  >{{ tr.status === true ? "active" : "inactive" }}
                </vs-chip>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr)"
                />
                <feather-icon
                  v-if="tr.status === true"
                  icon="XIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="ChangeStatus(tr, false)"
                />
                <feather-icon
                  v-if="tr.status === false"
                  icon="CheckIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="ChangeStatus(tr, true)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import VehicleForm from "./components/VehicleForm.vue";
export default {
  components: {
    VehicleForm,
  },
  data() {
    return {
      itemsPerPage: 4,
      isMounted: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    vehicles() {
      return this.$store.state.vehicle.vehicles;
    },
  },
  methods: {
    closeCardAnimationDemo(card) {
      card.removeRefreshAnimation(3000);
      setTimeout(() => {
        this.$store.dispatch("vehicle/fetchDataListItems");
      }, 3000);
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    ChangeStatus(tr, val) {
      this.$store
        .dispatch(`vehicle/updateItem`, {
          id: tr.id,
          eld_id: tr.eld_id,
          license_plate_issue_state: tr.license_plate_issue_state,
          license_plate_num: tr.license_plate_num,
          make: tr.make,
          model: tr.model,
          vehicle_id: tr.vehicle_id,
          year: tr.year,
          status: val,
        })
        .then(() => {
          this.$store.dispatch("vehicle/fetchDataListItems");
        });
    },
    getOrderStatusColor(status) {
      if (status === true) return "success";
      if (status === false) return "danger";
      return "success";
    },
    toggleDataSidebar(val = false) {
      this.$store.dispatch("vehicle/fetchDataListItems");
      this.addNewDataSidebar = val;
      this.$store.dispatch("vehicle/fetchDataListItems");
    },
  },
  created() {
    this.$store.dispatch("vehicle/fetchDataListItems");
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
